<template>
  <HeaderBar />

  <ButtonBackContainer>
    <ButtonBack :fallback="{ name: 'approvalRequests' }">{{
      t('backToApprovalRequests')
    }}</ButtonBack>
  </ButtonBackContainer>

  <section class="carvia-container">
    <div v-if="approvalRequest" class="space-y-4">
      <ApprovalRequestItem
        :approval-request="approvalRequest"
        :is-assigned-to-me="isAssignedToMe"
      />
    </div>

    <EntityListExceptions
      :status="approvalRequestStatus"
      :error="approvalRequestError"
      :items-count="approvalRequest ? 1 : 0"
      :no-items-text="t('approvalRequestNotFound')"
    />
  </section>
</template>

<script lang="ts" setup>
import HeaderBar from '@/components/headerbar/HeaderBar.vue';
import { useI18n } from 'vue-i18n';
import { computed, watchEffect } from 'vue';
import { useRoute } from 'vue-router';
import { useApprovalRequest } from '@/queries/use-approval-requests';
import ApprovalRequestItem from './ApprovalRequestItem.vue';
import { useUiStore } from '@/stores/ui.store';
import EntityListExceptions from '@/components/EntityListExceptions.vue';
import { useMe } from '@/queries/use-users';
import ButtonBackContainer from '@/components/ButtonBackContainer.vue';
import ButtonBack from '@/components/buttons/ButtonBack.vue';

const { t } = useI18n();
const uiStore = useUiStore();
const route = useRoute();
const { data: me } = useMe();

const approvalRequestId = computed(() => route.params.id as string);

const {
  data: approvalRequest,
  status: approvalRequestStatus,
  error: approvalRequestError,
} = useApprovalRequest(approvalRequestId);

const isAssignedToMe = computed(() => {
  if (!approvalRequest.value || !me.value) return false;

  return me.value.id !== approvalRequest.value.requester.id;
});

watchEffect(() => {
  uiStore.setHeaderTitle(t('approvalRequest'));
});
</script>

<i18n lang="json">
{
  "en": {
    "backToApprovalRequests": "Back to Approval Requests",
    "approvalRequest": "Approval Request",
    "approvalRequestNotFound": "Approval request not found"
  },
  "de": {
    "backToApprovalRequests": "Zurück zu Genehmigungsanfragen",
    "approvalRequest": "Genehmigungsanfrage",
    "approvalRequestNotFound": "Genehmigungsanfrage nicht gefunden"
  },
  "es": {
    "backToApprovalRequests": "Volver a solicitudes de aprobación",
    "approvalRequest": "Solicitud de aprobación",
    "approvalRequestNotFound": "No se encontró la solicitud de aprobación"
  }
}
</i18n>
